import type * as SchemaTypes from '../../../../apolloClient.types';

import type { March20kmPerformanceResultFragment, March20kmPerformanceResultDataFragment } from '../Create/CreatePerformanceMarch20KmResults.api';
import { gql } from '@apollo/client';
import { March20kmPerformanceResultFragmentDoc, March20kmPerformanceResultDataFragmentDoc } from '../Create/CreatePerformanceMarch20KmResults.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePerformanceMarch20KmResultMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  input: SchemaTypes.UpdateMarch20KmResultInput;
}>;


export type UpdatePerformanceMarch20KmResultMutation = (
  { __typename: 'Mutation' }
  & { updateMarch20KmResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'UpdateMarch20KmResultSuccessfulResponse' }
    & { result: (
      { __typename: 'PerformanceResult' }
      & March20kmPerformanceResultFragment
    ) }
  ) }
);


export const UpdatePerformanceMarch20KmResultDocument = /*#__PURE__*/ gql`
    mutation UpdatePerformanceMarch20KmResult($id: ObjectID!, $input: UpdateMarch20KmResultInput!) {
  updateMarch20KmResult(id: $id, input: $input) {
    ... on UpdateMarch20KmResultSuccessfulResponse {
      result {
        ...March20kmPerformanceResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${March20kmPerformanceResultFragmentDoc}
${March20kmPerformanceResultDataFragmentDoc}`;
export type UpdatePerformanceMarch20KmResultMutationFn = Apollo.MutationFunction<UpdatePerformanceMarch20KmResultMutation, UpdatePerformanceMarch20KmResultMutationVariables>;

/**
 * __useUpdatePerformanceMarch20KmResultMutation__
 *
 * To run a mutation, you first call `useUpdatePerformanceMarch20KmResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePerformanceMarch20KmResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePerformanceMarch20KmResultMutation, { data, loading, error }] = useUpdatePerformanceMarch20KmResultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePerformanceMarch20KmResultMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePerformanceMarch20KmResultMutation, UpdatePerformanceMarch20KmResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePerformanceMarch20KmResultMutation, UpdatePerformanceMarch20KmResultMutationVariables>(UpdatePerformanceMarch20KmResultDocument, options);
      }
export type UpdatePerformanceMarch20KmResultMutationHookResult = ReturnType<typeof useUpdatePerformanceMarch20KmResultMutation>;
export type UpdatePerformanceMarch20KmResultMutationResult = Apollo.MutationResult<UpdatePerformanceMarch20KmResultMutation>;
export type UpdatePerformanceMarch20KmResultMutationOptions = Apollo.BaseMutationOptions<UpdatePerformanceMarch20KmResultMutation, UpdatePerformanceMarch20KmResultMutationVariables>;